import { ElementTypeDTO, ImageTypeDTO } from '@/model';

export const elementTypeMap = new Map<ElementTypeDTO, ImageTypeDTO>([
  [ElementTypeDTO.IMAGE_DISPLAY_NORMAL, ImageTypeDTO.IMAGE_DISPLAY_NORMAL],
  [ElementTypeDTO.PAGER, ImageTypeDTO.PAGER],
]);

export const imageElementTypeMap = new Map<ElementTypeDTO, ImageTypeDTO[]>([
  [
    ElementTypeDTO.IMAGE_DISPLAY_NORMAL,
    [
      ImageTypeDTO.IMAGE_DISPLAY_NORMAL,
      ImageTypeDTO.DYNAMIC_TIMETABLE_BACKGROUND,
      ImageTypeDTO.STATIC_TIMETABLE,
      ImageTypeDTO.GENERAL_BACKGROUND,
    ],
  ],
  [ElementTypeDTO.PAGER, [ImageTypeDTO.PAGER]],
]);
